<template lang="">
    <div>
        <p>第一个页面显示内容</p>
    </div>
</template>
<script>
export default {

}
</script>
<style lang="">

</style>
